import { idSchema } from './validation';

const fileNameSchema = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};

// AJVVersion9 JSONSchemaType<number>
export const fileSizeSchema = {
  type: 'integer',
  minimum: 0,
};

// Schema validated using `JSONSchemaType<MessageFileElement>`
export const fileElementSchema = {
  type: 'object',
  properties: {
    _id: idSchema,
    name: fileNameSchema,
    size: fileSizeSchema,
  },
  required: ['fileId', 'name', 'size'],
  additionalProperties: false,
};
